import React, {
  useEffect,
  useState
} from "react";

import api from "../api";

export default function SejoursList() {

  const [sejours, setSejours] =
    useState([]);

  const [filter, setFilter] =
    useState("all");

  const formatDate = (value) => {
    if (!value) return "-";

    const datePart = String(value).split("T")[0];
    const [year, month, day] = datePart.split("-");

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    fetchSejours();
  }, []);

  // =====================
  // FETCH
  // =====================

  const fetchSejours =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "accessToken"
          );

        const res =
          await api.get(
            "/sejours",
            {
              headers: {
                Authorization:
                  "Bearer " +
                  token
              }
            }
          );

        setSejours(
          Array.isArray(
            res.data
          )
            ? res.data
            : []
        );

      } catch (err) {

        console.error(
          "Erreur chargement séjours :",
          err.response ||
            err.message
        );

        setSejours([]);

      }
    };

  // =====================
  // TERMINER
  // =====================

  const terminer =
    async (id) => {

      if (
        !window.confirm(
          "Clôturer ce séjour ?"
        )
      ) {
        return;
      }

      try {

        const token =
          localStorage.getItem(
            "accessToken"
          );

        await api.post(
          `/sejours/terminer/${id}`,
          {},
          {
            headers: {
              Authorization:
                "Bearer " +
                token
            }
          }
        );

        fetchSejours();

      } catch (err) {

        console.error(
          "Erreur terminaison :",
          err.response ||
            err.message
        );

      }
    };

  // =====================
  // FILTERS
  // =====================

  const filteredSejours =
    sejours.filter((s) => {

      if (filter === "actif") {
        return !s.expire;
      }

      if (filter === "expire") {
        return s.expire
      }

      return true;
    });

  const expiredCount =
    sejours.filter(
       (s) => s.expire
    ).length;

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-5 min-h-[100dvh] bg-gray-100">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-3">

        <h2 className="text-2xl md:text-3xl font-bold">
          📋 Séjours
        </h2>

        <span className="bg-red-500 text-white px-3 py-2 rounded-xl text-sm font-bold w-fit">
          {expiredCount} expirés
        </span>

      </div>

      {/* FILTERS */}
      <div className="flex gap-2 flex-wrap mb-4">

        {[
          {
            key: "all",
            label: "Tous"
          },
          {
            key: "actif",
            label: "Actifs"
          },
          {
            key: "expire",
            label: "Expirés"
          },
          
        ].map((btn) => (

          <button
            key={btn.key}
            onClick={() =>
              setFilter(
                btn.key
              )
            }
            className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
              filter === btn.key
                ? "bg-indigo-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {btn.label}
          </button>

        ))}

      </div>

      {/* ALERT */}
      {expiredCount > 0 &&
        filter !==
          "expire" && (

          <div className="bg-red-100 text-red-700 px-4 py-3 rounded-xl mb-4 text-sm shadow">
            ⚠️ Des séjours expirés nécessitent une action
          </div>

        )}

      {/* LIST */}
      <div className="grid gap-3">

        {filteredSejours.map(
          (s) => (

            <div
              key={s.id}
              className={`rounded-2xl p-4 shadow border flex flex-col md:flex-row md:justify-between gap-4 ${
                s.expire
                  ? "border-red-500 bg-red-50"
                  : "bg-white"
              }`}
            >

              {/* INFOS */}
              <div className="flex flex-col gap-2">

                {/* TOP */}
                <div className="flex items-center gap-2 flex-wrap">

                  <span className="font-bold text-lg">
                    🏠{" "}
                    {s.appartement_numero ||
                      "?"}
                  </span>

                  {s.expire ? (

                 
                    <span className="bg-red-600 text-white text-xs px-2 py-1 rounded-full">
                      Expiré
                    </span>

                  ) : (

                    <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full">
                      Actif
                    </span>

                  )}

                </div>

                {/* DATES */}
                <div className="text-sm text-gray-600">

                  📅 Début :{" "}
                  {formatDate(s.date_debut)}

                </div>

                <div className="text-sm text-gray-600">

                  ⏳ Fin :{" "}
                  {formatDate(s.date_fin_prevue)}

                </div>

              </div>

              {/* ACTIONS */}
              <div className="flex items-center justify-start md:justify-end gap-2">

                {s.expire && (

                    <button
                      onClick={() =>
                        terminer(
                          s.id
                        )
                      }
                      className="bg-black hover:bg-gray-800 transition text-white px-4 py-2 rounded-xl text-sm"
                    >
                      Clôturer
                    </button>

                  )}

              </div>

            </div>

          )
        )}

        {/* EMPTY */}
        {filteredSejours.length ===
          0 && (

          <div className="text-center text-gray-500 py-10 bg-white rounded-2xl shadow">
            Aucun séjour trouvé
          </div>

        )}

      </div>

    </div>
  );
}